'use client'

import { useCollectionData } from '@/app/[locale]/collection/hooks/use-collection-data'
import { cn } from '@/lib/utils'
import type { TCollectionData } from '@/types/collection'

type Props = {
  children?: React.ReactNode
  title?: string
  className?: string
  titleClassName?: string
  // Optional props để enable auto-update title từ collection data
  serverData?: TCollectionData
  initialFilters?: Record<string, string | string[] | number | undefined>
  hideTitle?: boolean
}

export const CollectionHeader = ({
  children,
  title,
  className,
  titleClassName,
  serverData,
  initialFilters,
  hideTitle,
}: Props) => {
  // Nếu có serverData và initialFilters, tự động subscribe vào collection data để update title
  // Hook phải được gọi unconditionally, nhưng chỉ enable khi có serverData
  const { data } = useCollectionData({
    serverData: serverData || ({} as TCollectionData),
    initialFilters: initialFilters || {},
  })

  // Get title từ latest data nếu có serverData, fallback về title prop
  // Priority: latest data > serverData > title prop
  const displayTitle =
    serverData && initialFilters
      ? (data?.pages?.[0]?.collection_detail?.title_display ??
        serverData?.collection_detail?.title_display ??
        title)
      : title

  return (
    <div className={className}>
      {!hideTitle && displayTitle ? (
        <h1
          className={cn(
            'font-criteria text-2xl font-medium uppercase leading-9 text-neutral-900 lg:text-[28px] lg:leading-10',
            titleClassName
          )}
        >
          {displayTitle}
        </h1>
      ) : null}
      {children}
    </div>
  )
}
